<template>
<div>
  <v-app-bar app>
    <v-app-bar-nav-icon @click="drawer = !drawer" v-if="validPage"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
    <dark-mode-switch></dark-mode-switch>
    <bell-icon v-if="$store.state.query.connected"></bell-icon>
  </v-app-bar>

  <v-navigation-drawer app v-model="drawer" v-if="validPage" width="300">
    <v-list dense class="pt-2" subheader nav>
      <v-list-item two-line>
          <logo height="50" style="margin: auto;"></logo>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        v-for="(entry, i) in menuEntries"
        v-if="!entry.submenu"
        :key="i"
        @click="pushRoute(entry)"
        :class="{'v-list-item--active': $route.name === entry.route.name}"
      >
        <v-list-item-icon>
          <v-badge color="error" :value="entry.title === 'Chat' && $store.getters.unreadMessages">
            <template #badge>
              <span>{{ $store.getters.unreadMessages }}</span>
            </template>
            <v-icon>{{ entry.icon }}</v-icon>
          </v-badge>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ entry.title }}
            <v-icon v-if="entry.experimental">mdi-test-tube</v-icon>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group v-else no-action :prepend-icon="entry.icon">
        <template #activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{ entry.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item
          v-for="(subEntry, j) in entry.submenu"
          :key="j"
          @click="pushRoute(subEntry)"
          :class="{'v-list-item--active': $route.name === subEntry.route.name}"
        >
          <v-list-item-icon>
            <v-icon>{{ subEntry.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ subEntry.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
    <template v-slot:append>
      <div class="pa-2 text-center" >
          TS3-Manager {{ version }}
      </div>
    </template>
  </v-navigation-drawer>
</div>
</template>

<script>
import Logo from "@/components/Logo";
import { version } from "../../package.json";
export default {
  components: {
    DarkModeSwitch: () => import('@/components/DarkModeSwitch'),
    BellIcon: () => import('@/components/BellIcon'),
    Logo
  },
  data() {
    return {
      version,
      mini: true,
      drawer: null,
      menuEntries: [
        // {
        //   title: 'Server List',
        //   icon: 'dns',
        //   route: {name: 'servers'},
        // },
        {
          title: 'Server Übersicht',
          icon: 'remove_red_eye',
          route: {name: 'serverviewer'}
        },
        {
          title: 'Server Verwalten',
          icon: 'settings',
          route: {name: 'server-edit'}
        },
        {
          title: 'Datei Manager',
          icon: 'mdi-folder',
          route: {name: 'files'}
        },
        // {
        //   title: 'Backup/Restore',
        //   icon: 'settings_backup_restore',
        //   route: {name: 'snapshot'}
        // },
        {
          title: 'Berechtigungsschlüssel',
          icon: 'mdi-key',
          route: {name: 'tokens'}
        },
        {
          title: 'Nachrichten',
          icon: 'mail_outline',
          route: {name: 'chat'}
        },
        {
          title: 'Benutzer',
          icon: 'person',
          route: {name: 'clients'}
        },
        {
          title: 'Ban Liste',
          icon: 'not_interested',
          route: {name: 'bans'}
        },
        {
          title: 'Konsole',
          icon: 'mdi-console',
          route: {name: 'console'}
        },
        {
          title: 'Beschwerden',
          icon: 'warning',
          route: {name: 'complaints'}
        },
        {
          title: 'Server Log',
          icon: 'mdi-file-document-outline',
          route: {name: 'logs'}
        },
        {
          title: 'Servergruppen',
          icon: 'group',
          route: {name: 'servergroups'}
        },
        {
          title: 'Channelgruppen',
          icon: 'mdi-hexagon-slice-4',
          route: {name: 'channelgroups'}
        },
        {
          title: 'Rechte',
          icon: 'mdi-format-section',
          submenu: [{
              title: 'Servergruppen',
              icon: 'group',
              route: {name: 'permissions-servergroup'}
            },
            {
              title: 'Clientrechte',
              icon: 'person',
              route: {name: 'permissions-client'}
            },
            {
              title: 'Channelrechte',
              icon: 'mdi-hexagon-slice-4',
              route: {name: 'permissions-channel'}
            },
            {
              title: 'Channelgruppen',
              icon: 'mdi-hexagon-slice-4',
              route: {name: 'permissions-channelgroup'}
            },
            {
              title: 'Benutzer Channelrechte',
              icon: 'mdi-hexagon-slice-4',
              route: {name: 'permissions-channelclient'}
            },
          ]
        },
        {
          title: 'Ausloggen',
          icon: 'exit_to_app',
          route: {name: 'logout'}
        }
      ],
    }
  },
  computed: {
    validPage() {
      if (this.$route.name === 'login' || this.$route.name === '404') {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    pushRoute(entry) {
      if(entry.route.name !== this.$route.name) {
        this.$router.push(entry.route)
      }
    }
  },
}
</script>
